import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const ePhanGiaoVienActionsObj = {
    CHANGE_SELECTED_GIAOVIEN_ID: ""
}
export const eGiaoVienActionIds = generateActionTypeIds(
    ePhanGiaoVienActionsObj,
    "PHAN_GIAO_VIEN"
  );
  export type IPhanGiaoVienActionTypes = IGenericActionType<
    typeof ePhanGiaoVienActionsObj,
    "PHAN_GIAO_VIEN"
  >;
  